import { AddViewSupport411Container } from "../../../containers/SupportSystem/ViewReports/AddViewSupport411Container"
export function AddViewSupport411Page() {
    return (
        <AddViewSupport411Container />
    )
}